import { mapState } from "vuex";

export default {
  name: "messages_counter",

  data() {
    return {};
  },

  mounted: function() {},

  computed: mapState(["twilioMessagesCounter"]),

  methods: {}
};
